import React from 'react';
import { FiCheckCircle, FiFileText, FiUsers, FiTarget } from 'react-icons/fi';
import classNames from 'classnames/bind';

import styles from './Exams.module.scss';

const cx = classNames.bind(styles);

function ExamsOverview({ totalExams, totalSubjects, totalAssignments, completionRate }) {
    const safeCompletionRate = Number.isFinite(completionRate) ? completionRate : 0;

    const metrics = [
        {
            id: 'exams',
            label: 'Tổng số đề thi',
            value: totalExams,
            icon: <FiFileText size={20} />,
            accent: 'overview-card--accent_blue',
        },
        {
            id: 'subjects',
            label: 'Số chuyên đề',
            value: totalSubjects,
            icon: <FiTarget size={20} />,
            accent: 'overview-card--accent_purple',
        },
        {
            id: 'assignments',
            label: 'Lượt nộp bài',
            value: totalAssignments,
            icon: <FiUsers size={20} />,
            accent: 'overview-card--accent_green',
        },
        {
            id: 'completion',
            label: 'Tỷ lệ nộp bài',
            value: `${safeCompletionRate.toFixed(0)}%`,
            icon: <FiCheckCircle size={20} />,
            accent: 'overview-card--accent_blue',
        },
    ];

    return (
        <section className={cx('overview-panel')}>
            {metrics.map((metric) => (
                <article key={metric.id} className={cx('overview-card', metric.accent)}>
                    <span className={cx('overview-card__icon')}>{metric.icon}</span>
                    <div>
                        <p>{metric.label}</p>
                        <strong>{metric.value}</strong>
                    </div>
                </article>
            ))}
        </section>
    );
}

export default ExamsOverview;
